// extracted by mini-css-extract-plugin
module.exports = {"fieldContainer":"AppointmentTypeName_fieldContainer__1yjYV","fieldError":"AppointmentTypeName_fieldError__2C411"};